document.addEventListener('DOMContentLoaded', function() {
  function initStickyATC() {
    const stickyATC = document.querySelector('.sticky-atc-bar');
    const mainButton = document.querySelector('button.product-form__cart-submit');

    if (!stickyATC || !mainButton) {
      console.log('Sticky ATC ou bouton principal introuvable, réessaie dans 100ms...');
      setTimeout(initStickyATC, 100);
      return;
    }

    function toggleSticky() {
      const rect = mainButton.getBoundingClientRect();
      const isBelowButton = rect.bottom < 0;

      if (isBelowButton) {
        stickyATC.classList.remove('hidden');
        stickyATC.classList.add('visible');
      } else {
        stickyATC.classList.add('hidden');
        stickyATC.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', toggleSticky);
    window.addEventListener('resize', toggleSticky);
    toggleSticky();
  }

  initStickyATC();
});